__turbopack_context__.v({
  "counter": "use-counter-module__fHxppq__counter",
});
